/** Datos simulados DIAN para demo (en producción el backend integra con DIAN). */
export interface BillDianSimulation {
  /** Código Único de Factura Electrónica */
  cufe: string;
  /** Imagen QR en base64 (data URL) con el CUFE para consulta */
  qrBase64?: string;
  /** Número de resolución de facturación autorizada por la DIAN */
  resolutionNumber: string;
  /** Prefijo del establecimiento (ej. FE) */
  invoicePrefix: string;
  /** Número consecutivo de la factura */
  invoiceNumber: string;
  /** Fecha de autorización de la resolución (demo) */
  authorizationDate: Date;
}

export class Bill {
  id: string;
  orderId: string;
  tableId: string;
  /** IDs de todos los pedidos incluidos en esta factura (cuando se agrupan varios). */
  orderIds?: string[];
  linkedTableIds: string[];
  subtotal: number;
  tax: number;
  discount: number;
  total: number;
  paymentMethod?: 'CASH' | 'CARD' | 'DIGITAL_WALLET';
  tip?: number;
  notes?: string;
  createdAt: Date;
  paidAt?: Date;
  status: 'DRAFT' | 'FINALIZED' | 'PAID' | 'CANCELLED';
  /** Datos simulados DIAN para representación gráfica (demo). En producción provienen del backend. */
  dian?: BillDianSimulation;

  constructor(id: string, orderId: string, tableId: string, subtotal: number, tax: number, discount: number) {
    this.id = id;
    this.orderId = orderId;
    this.tableId = tableId;
    this.linkedTableIds = [];
    this.subtotal = subtotal;
    this.tax = tax;
    this.discount = discount;
    this.total = subtotal + tax - discount;
    this.status = 'DRAFT';
    this.createdAt = new Date();
  }

  addTip(tipAmount: number): void {
    this.tip = tipAmount;
    this.total = this.subtotal + this.tax - this.discount + tipAmount;
  }

  pay(method: 'CASH' | 'CARD' | 'DIGITAL_WALLET'): void {
    this.paymentMethod = method;
    this.paidAt = new Date();
    this.status = 'PAID';
  }

  finalize(): void {
    this.status = 'FINALIZED';
  }

  cancel(): void {
    this.status = 'CANCELLED';
  }
}
